import React, { useState, useEffect, useRef, Fragment, useCallback } from 'react';
import ProtectedRoute from '../../routes/protected';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import performanceService from '../../services/data/performance.service';
import moment from "moment";
import 'moment/locale/pt-br'
import { Toast } from 'primereact/toast';
import { useFormik } from 'formik';
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle'
import { useParams, useLocation } from 'react-router-dom';
import { Avatar } from 'primereact/avatar';
import NameInitials from '../../helpers/nameInitials';
import SkeletonProcess from './skeletonProcess';
import companyService from '../../services/data/company.service';
import { Dropdown } from 'primereact/dropdown';
import PerformanceReportStepCommentsRows, {
    performanceReportStepResponsesAvailable,
} from './performanceReportStepComments';
import useCompanyData from '../../context/company';


export default function PerformanceTemplateReport() {

    const { rootUser } = useCompanyData();
    const [responsesOpenKey, setResponsesOpenKey] = useState(null);
    const [pageLoad, setPageLoad] = useState(true)
    const [filterLoad, setFilterLoad] = useState(false)
    const toast = useRef(null);
    const [object, setObject] = useState([]);
    const [page, setPage] = useState(1)
    const [itemsCount, setItemsCount] = useState(0)
    const [report, setReport] = useState('')

    const { id } = useParams()
    const location = useLocation()

    const [subCompaniesList, setSubCompaniesList] = useState([]) // lista de subCompanies
    const [subcompany, setSubcompany] = useState('')

    const [internalJobTitlesList, setInternalJobTitlesList] = useState([]) // lista de cargos
    const [internalJobTitle, setInternalJobTitle] = useState('')

    const [departmentsList, setDepartmentsList] = useState([]) // lista de departamentos
    const [department, setDepartment] = useState('')
    const [filtersApplied, setFiltersApplied] = useState(false)

    // remover employee do processo
    const [reviewId, setReviewId] = useState('')
    const [employeeManagerName, setEmployeeManagerName] = useState('')
    const [employeeManagerId, setEmployeeManagerId] = useState('')
    const [deleteEmployeeId, setDeleteEmployeeId] = useState('')
    const [deleteEmployeeName, setDeleteEmployeeName] = useState('')
    const modalRef = useRef()

    const hideModal = () => {
        const modalEl = modalRef.current
        const bsModal= bootstrap.Modal.getInstance(modalEl)
        bsModal.hide()
    }

    useEffect(() => {
        listSubCompanies()
        listInternalJobTitles()
        listDepartments()
    }, [])

    const getReport = useCallback(() => {
        let data = {
            template_id: id,
            company_id: localStorage.getItem("companyId")
        }
        performanceService.getPerformanceTemplateReport(page, data).then((response) => {

            setReport(response)
            setPageLoad(false)
            setItemsCount(response.count)
        })
    }, [id, page])

    useEffect(() => {
        if (location && location.state && location.state.item) {
            setObject(location.state.item)
        }
        getReport()
    }, [location, getReport])

    function listSubCompanies() {

        const getItem = ''

        companyService.autoCompleteSubCompany(getItem).then((response) => {
        
            let res = response.map((item) => {
                return {
                    title: item.title,
                    value: item.id
                }
            })
            setSubCompaniesList(res)

        })
        .catch((error) => {
            console.log(error.response.data)
        });

    }

    function listInternalJobTitles() {

        const getItem = ''

        companyService.autoCompleteInternalJobTitles(getItem).then((response) => {
            let res = response.map((item) => {
                return {
                    title: item.title,
                    value: item.id
                }
            })
            setInternalJobTitlesList(res)
        }).catch((error) => {
            console.log(error.response.data)
        })
    }

    function listDepartments() {

        const getItem = ''

        companyService.autoCompleteDepartment(getItem).then((response) => {
            let res = response.map((item) => {
                return {
                    title: item.title,
                    value: item.id
                }
            })
            setDepartmentsList(res)
        }).catch((error) => {
            console.log(error.response.data)
        })
    }

    const STATUS_MAP = {
        'NI': 'Não Iniciado',
        'PE': 'Em Andamento',
        'RE': 'Realizado',
    }

    const PERFORMANCE_STATUS_MAP = {
        'AT': 'Ativo',
        'EP': 'Em Processo',
        'CO': 'Concluído',
        'AR': 'Arquivado',
        'CA': 'Cancelado',
    }

    const styles = {
        minHeight: '500px',
        paddingBottom: '200px'
    }

    function addPage() {
        setPage(page + 1)
    }

    function subPage() {
        setPage(page - 1)
    }

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            name: '',
        },
        onSubmit: values => {

            setFilterLoad(true)

            let data = {
                company_id: localStorage.getItem("companyId"),
                template_id: id,
                name: values.name,
            }

            if (subcompany) {
                data.subcompany_id = subcompany
            }

            if (internalJobTitle) {
                data.internal_job_title_id = internalJobTitle
            }
            
            if (department) {
                data.department_id = department
            }

            performanceService.getPerformanceTemplateReport(page, data).then((response) => {
                setReport(response)
                setPageLoad(false)
                setItemsCount(response.count)
                setFiltersApplied(true)
            }).catch((error) => {
                console.log(error.response)
                toast.current.show({ severity: 'warn', summary: 'Ops', detail: JSON.stringify(error.response.data), life: 4000 })
            }).finally(() => {
                setFilterLoad(false)
            })
        }
    })

    function exportReport() {
        let data = {
            company_id: localStorage.getItem("companyId"),
            template_id: id,
        }
        performanceService.exportPerformanceReviewReport(data).then((response) => {
            toast.current.show({ severity: 'success', summary: 'Sucesso', detail: response.message, life: 4000 });
        }).catch((error) => {
            toast.current.show({ severity: 'error', summary: 'Ops', detail: JSON.stringify(error.response.data), life: 10000 });
        })
    }

    function exportEmployeeXLS(employee, reviewItem) {
        const data = {
            company_id: localStorage.getItem("companyId"),
            review_id: reviewItem.review_id,
            employee_id: employee.employee_id,
        }
        performanceService.exportEmployeeReviewReport(data).then((response) => {
            toast.current.show({ severity: 'success', summary: 'Sucesso', detail: response.message, life: 4000 });
        }).catch((error) => {
            toast.current.show({ severity: 'error', summary: 'Ops', detail: JSON.stringify(error.response?.data), life: 10000 });
        })
    }

    function printEmployeePDF(employee, reviewItem) {
        const steps = (employee.steps || []).filter(s => s.step_type !== 'AS');

        const itemsMap = new Map();
        for (const step of steps) {
            for (const sess of (step.step_item_sessions || [])) {
                for (const it of (sess.items || [])) {
                    if (!itemsMap.has(it.item_id)) {
                        itemsMap.set(it.item_id, {
                            title: it.item_title || '-',
                            sessionTitle: sess.session_title || '',
                            sessionOrder: sess.session_order ?? 0,
                        });
                    }
                }
            }
        }

        const sortedItems = [...itemsMap.entries()].sort(
            ([, a], [, b]) => a.sessionOrder - b.sessionOrder || a.sessionTitle.localeCompare(b.sessionTitle)
        );

        const stripHtml = (html) => (html || '').replace(/<[^>]+>/g, '').trim() || '-';

        const stepHeaders = steps.map(s =>
            `<th colspan="2" style="background:#388e3c;color:#fff;padding:6px 8px;border:1px solid #ccc;">${s.step_title}</th>`
        ).join('');

        const stepSubHeaders = steps.map(() =>
            `<th style="background:#e8f5e9;padding:5px 8px;border:1px solid #ccc;">Nota</th><th style="background:#e8f5e9;padding:5px 8px;border:1px solid #ccc;">Comentário</th>`
        ).join('');

        const dataRows = sortedItems.map(([itemId, itemInfo]) => {
            const cells = steps.map(step => {
                let nota = '-', comentario = '-';
                for (const sess of (step.step_item_sessions || [])) {
                    const found = (sess.items || []).find(it => it.item_id === itemId);
                    if (found) {
                        if (found.rating_label) {
                            nota = found.rating_score !== null && found.rating_score !== ''
                                ? `${found.rating_label} (${found.rating_score}/5)`
                                : found.rating_label;
                        }
                        if (found.comment) {
                            comentario = stripHtml(found.comment);
                        }
                        break;
                    }
                }
                return `<td style="padding:5px 8px;border:1px solid #ddd;vertical-align:top;">${nota}</td><td style="padding:5px 8px;border:1px solid #ddd;vertical-align:top;">${comentario}</td>`;
            }).join('');

            return `<tr>
                <td style="padding:5px 8px;border:1px solid #ddd;vertical-align:top;">${itemInfo.sessionTitle}</td>
                <td style="padding:5px 8px;border:1px solid #ddd;vertical-align:top;">${itemInfo.title}</td>
                ${cells}
            </tr>`;
        }).join('');

        const noItemsRow = sortedItems.length === 0
            ? `<tr><td colspan="${2 + steps.length * 2}" style="padding:10px;text-align:center;color:#777;">Nenhum item registrado.</td></tr>`
            : '';

        const html = `<!DOCTYPE html>
<html lang="pt-BR">
<head>
<meta charset="UTF-8">
<title>Relatório - ${employee.employee_name}</title>
<style>
  body { font-family: Arial, sans-serif; font-size: 11px; margin: 20px; }
  h2 { color: #2e7d32; margin-bottom: 8px; }
  .meta p { margin: 3px 0; }
  table { width: 100%; border-collapse: collapse; margin-top: 16px; }
  tr:nth-child(even) td { background: #f9f9f9; }
  @media print { body { margin: 10px; } }
</style>
</head>
<body>
<h2>Relatório de Performance</h2>
<div class="meta">
  <p><strong>Título:</strong> ${reviewItem.perforamce_title || ''}</p>
  <p><strong>Data:</strong> ${new Date().toLocaleDateString('pt-BR')}</p>
  <p><strong>Gestor:</strong> ${reviewItem.manager?.name || ''}</p>
  <p><strong>Avaliado:</strong> ${employee.employee_name}</p>
  ${employee.employee_organization ? `<p><strong>Organização:</strong> ${employee.employee_organization}</p>` : ''}
  ${employee.employee_department ? `<p><strong>Departamento:</strong> ${employee.employee_department}</p>` : ''}
</div>
<table>
  <thead>
    <tr>
      <th rowspan="2" style="background:#388e3c;color:#fff;padding:6px 8px;border:1px solid #ccc;">Sessão</th>
      <th rowspan="2" style="background:#388e3c;color:#fff;padding:6px 8px;border:1px solid #ccc;">Item</th>
      ${stepHeaders}
    </tr>
    <tr>${stepSubHeaders}</tr>
  </thead>
  <tbody>
    ${dataRows}
    ${noItemsRow}
  </tbody>
</table>
</body>
</html>`;

        const win = window.open('', '_blank');
        if (win) {
            win.document.write(html);
            win.document.close();
            win.focus();
            setTimeout(() => win.print(), 500);
        }
    }

    function deleteItem() {
        var data = {
            managerId: employeeManagerId,
            employeeId: deleteEmployeeId,
            id: reviewId,
            company_id: localStorage.getItem("companyId")
        }
        performanceService.removePerformanceProcess(data).then(() => {
            toast.current.show({ severity: 'success', summary: 'Sucesso', detail: 'Participante removido com sucesso', life: 3000 });
            getReport()
        })
        .catch((error) => {
            toast.current.show({ severity: 'warn', summary: 'Ops', detail: JSON.stringify(error.response.data), life: 4000 });
        })
        .finally(() => {
            hideModal()
        })
    }

    return (
        <ProtectedRoute>
            <Toast ref={toast} position="top-right" />

            <div className="container-fluid">
                <div className='row flex-nowrap'>
                    <div className='col text-bg-green p-3'>
                        <a href='/performance-template/list/' className="fs-6 fw-bold ps-5 text-decoration-none text-white">
                            <FontAwesomeIcon className='' icon={solid('arrow-left')} /> Performance
                        </a>
                    </div>
                </div>
                <div className='my-4 mx-5 pt-3 rounded-top' style={styles}>
                    <h6 className='fw-bold'>Relatório {object?.title ? `- ${object.title}` : ''}</h6>

                    <div className='bg-white p-3 mb-2 rounded border-clean'>

                        <div className='row'>
                            <div className='col-3'>
                                <p className='fw-bold mt-3'>Filtros</p>
                                <form className='bg-light p-3 rounded' onSubmit={formik.handleSubmit}>
                                    <div className="col mb-3">
                                        <label className="form-label">Nome</label>
                                        <input name='name' type="text" className="form-control" {...formik.getFieldProps('name')} />
                                    </div>
                                    <div className="col mb-3">
                                        <label className="form-label">Organização</label>
                                        <div className='p-inputgroup'>
                                            <Dropdown filter placeholder="Selecionar" value={subcompany} optionLabel="title" optionValue="value" options={subCompaniesList} onChange={(e) => {setSubcompany(e.value);} } className="rounded" />
                                        </div>
                                    </div>
                                    <div className="col mb-3">
                                        <label className="form-label">Cargos</label>
                                        <div className='p-inputgroup'>
                                            <Dropdown filter placeholder="Selecionar" value={internalJobTitle} optionLabel="title" optionValue="value" options={internalJobTitlesList} onChange={(e) => {setInternalJobTitle(e.value);} } className="rounded" />
                                        </div>
                                    </div>
                                    <div className="col mb-3">
                                        <label className="form-label">Departamento</label>
                                        <div className='p-inputgroup'>
                                            <Dropdown filter placeholder="Selecionar" value={department} optionLabel="title" optionValue="value" options={departmentsList} onChange={(e) => {setDepartment(e.value);} } className="rounded" />
                                        </div>
                                    </div>
                                    
                                    <div className="btnMargin">
                                        <button className="btn btn-success btn-sm btn-rounded px-4" type="submit" disabled={filterLoad}>
                                            Filtrar
                                        </button>
                                        {
                                            filtersApplied ?
                                            <span role='button' className='fw-bold float-end mt-2' onClick={() => {
                                                setSubcompany('')
                                                setInternalJobTitle('')
                                                setDepartment('')
                                                setFiltersApplied(false)
                                                setPage(1)
                                                formik.resetForm()
                                                getReport()
                                            }}>Limpar</span>
                                            :null
                                        }
                                        
                                    </div>
                                </form>
                            </div>
                            <div className='col'>
                            {
                                pageLoad ?
                                <SkeletonProcess />
                                :
                                report && report.results && report.results.length > 0 ?
                                <>
                                <div className='row mt-3'>
                                    <div className='col-12'>
                                        <div className='d-flex justify-content-end'>
                                            <button className='btn btn-success btn-sm btn-rounded px-4' onClick={() => {
                                                exportReport()
                                            }}>
                                                Exportar
                                            </button>
                                        </div>
                                    </div>
                                    <div className='col'>
                                        <p className='fw-bold'>
                                            {
                                                report.results.length === 1 ?
                                                `Mostrando ${report.results.length} resultado de ${itemsCount}`
                                                :
                                                `Mostrando ${report.results.length} resultados de ${itemsCount} `
                                            }
                                        </p>
                                    </div>
                                    <div className='col' style={{paddingRight: '0'}}>
                                    {
                                        itemsCount > 20 ?
                                        <>
                                        <div className='d-flex justify-content-end'>
                                            <nav>
                                                <ul className='pagination pagination-sm'>
                                                    <li className='page-item'>
                                                        { 
                                                            report.previous ? 
                                                            <span onClick={subPage} className='page-link text-default'>
                                                                <FontAwesomeIcon className='' icon={solid('angle-left')} />
                                                            </span>
                                                            :
                                                            <span className='page-link text-grey disabled'>
                                                                <FontAwesomeIcon className='' icon={solid('angle-left')} />
                                                            </span>
                                                        }
                                                    </li>
                                                    <li className='page-item'>
                                                        {
                                                            report.next ?
                                                            <span onClick={addPage} className='page-link text-default'>
                                                                <FontAwesomeIcon className='' icon={solid('angle-right')} />
                                                            </span>
                                                            :
                                                            <span className='page-link text-grey disabled'>
                                                                <FontAwesomeIcon className='' icon={solid('angle-right')} />
                                                            </span>
                                                        }
                                                    </li>
                                                </ul>
                                            </nav>
                                        </div>
                                        </>
                                        : null
                                    }
                                    </div>
                                </div>
                                
                                
                                {
                                    report.results.map((item) => (
                                        <React.Fragment key={item.review_id}>
                                            {(item.assessment_type === 'SD' || item.assessment_type === 'TD') &&
                                            !rootUser &&
                                            item.item_comments_allowed === false ? (
                                                <div className="alert alert-secondary small py-2 mb-2" role="alert">
                                                    As respostas por item (metas, competências e perguntas) exigem a permissão{' '}
                                                    <strong>view_itemstatus</strong> no perfil (individual ou grupo).{' '}
                                                    Usuários <strong>root</strong> (dono da empresa) visualizam sem essa permissão.
                                                </div>
                                            ) : null}
                                            <table className='table border-clean w-100 mb-4'>
                                                <tbody>
                                                    <tr className='align-middle table-light'>
                                                        <td width="20px">
                                                            <Avatar title={item.manager.name} label={NameInitials( item.manager.name )} style={{ backgroundColor: '#555555', color: '#ffffff', fontWeight: 'bold' }} shape='circle' size="small" />
                                                        </td>
                                                        <th colSpan={2}>{item.manager.name}</th>
                                                        <th colSpan={3} className='text-end'>
                                                            {
                                                                item.performance_status ?
                                                                <>
                                                                {
                                                                    item.performance_status === 'AT' ?
                                                                    <span className='badge bg-secondary d-none'>{PERFORMANCE_STATUS_MAP[item.performance_status]}</span>
                                                                    :
                                                                    null
                                                                }
                                                                {
                                                                    item.performance_status === 'EP' ?
                                                                    <span className='badge bg-primary d-none'>{PERFORMANCE_STATUS_MAP[item.performance_status]}</span>
                                                                    :
                                                                    null
                                                                }
                                                                {
                                                                    item.performance_status === 'CO' ?
                                                                    <span className='badge bg-success d-none'>{PERFORMANCE_STATUS_MAP[item.performance_status]}</span>
                                                                    :
                                                                    null
                                                                }
                                                                {
                                                                    item.performance_status === 'AR' ?
                                                                    <span className='badge bg-secondary d-none'>{PERFORMANCE_STATUS_MAP[item.performance_status]}</span>
                                                                    :
                                                                    null
                                                                }
                                                                {
                                                                    item.performance_status === 'CA' ?
                                                                    <span className='badge bg-warning'>{PERFORMANCE_STATUS_MAP[item.performance_status]}</span>
                                                                    :
                                                                    null
                                                                }
                                                                </>
                                                                : null
                                                            }
                                                        </th>
                                                    </tr>
                                                
                                            
                                            {item.employees && item.employees.map((employee) => (
                                                <React.Fragment key={employee.employee_id}>
                                                    <tr className='align-middle'>
                                                        <td width="20px">
                                                            <Avatar title={employee.employee_name} label={NameInitials( employee.employee_name )} style={{ backgroundColor: '#42c0fb', color: '#ffffff', fontWeight: 'bold' }} shape='circle' size="small" />
                                                        </td>
                                                        <th colSpan={2}>
                                                            <div className='d-flex justify-content-start align-items-center w-100'>
                                                                <span className='fw-normal'>{employee.employee_name}</span> 
                                                                <div className='ms-2 dropdown'>
                                                                    <button className='btn btn-sm rounded-circle border dropdown-toggle no-caret' data-bs-toggle="dropdown" aria-expanded="false">
                                                                        <FontAwesomeIcon className='text-green' icon={solid('ellipsis')} />
                                                                    </button>
                                                                    <ul className='dropdown-menu border headerBorder font1em'>
                                                                        <li>
                                                                            <button className="dropdown-item text-default" onClick={() => exportEmployeeXLS(employee, item)}>
                                                                                Exportar XLS
                                                                            </button>
                                                                        </li>
                                                                        <li>
                                                                            <button className="dropdown-item text-default" onClick={() => printEmployeePDF(employee, item)}>
                                                                                Exportar PDF
                                                                            </button>
                                                                        </li>
                                                                        <li><hr className="dropdown-divider" /></li>
                                                                        <li>
                                                                            <button className="dropdown-item text-default"  data-bs-toggle="modal" data-bs-target="#formDel" onClick={() => {
                                                                                setDeleteEmployeeId(employee.employee_id)
                                                                                setDeleteEmployeeName(employee.employee_name)
                                                                                setEmployeeManagerName(item.manager.name)
                                                                                setReviewId(item.review_id)
                                                                                setEmployeeManagerId(item.manager.id)
                                                                            }}>
                                                                                Remover do Processo
                                                                            </button>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                            
                                                        </th>
                                                        <th colSpan={3} className='text-end'>
                                                            {
                                                                item.performance_status !== 'CO' ?
                                                                <span className='badge bg-success'>{PERFORMANCE_STATUS_MAP[employee.final_status]}</span>
                                                                : null
                                                            }
                                                        </th>
                                                    </tr>
                                                    <tr className='table-light'>
                                                        <th></th>
                                                        <th>Etapa</th>
                                                        <th className='text-center'>Vencimento</th>
                                                        <th className='text-center'>Status</th>
                                                        <th className='text-center'>Concluído em</th>
                                                        <th className='text-center'>Avaliação</th>
                                                    </tr>
                                                    {
                                                        employee.steps.map((step) => {
                                                            const commentsAllowed =
                                                                rootUser || item.item_comments_allowed;
                                                            const stepResponsesKey = `${item.review_id}-${employee.employee_id}-${step.step_id}`;
                                                            const showResponsesIcon =
                                                                performanceReportStepResponsesAvailable(
                                                                    step,
                                                                    commentsAllowed,
                                                                    item.assessment_type
                                                                );
                                                            return (
                                                            <Fragment key={step.step_id}>
                                                                <tr className='align-middle border-white'>
                                                                    <td></td>
                                                                    <td>
                                                                        <div className='d-flex align-items-center justify-content-between gap-2 flex-wrap w-100'>
                                                                            <div>
                                                                                <span>{step.step_title}</span>
                                                                                {step.step_type === 'AP' && step.action_by_name ? (
                                                                                    <small className='text-muted d-block'>Par: {step.action_by_name}</small>
                                                                                ) : null}
                                                                            </div>
                                                                            {showResponsesIcon ? (
                                                                                <button
                                                                                    type='button'
                                                                                    className='btn btn-link btn-sm p-0 text-green'
                                                                                    title={
                                                                                        responsesOpenKey === stepResponsesKey
                                                                                            ? 'Ocultar respostas'
                                                                                            : 'Ver respostas'
                                                                                    }
                                                                                    aria-expanded={
                                                                                        responsesOpenKey === stepResponsesKey
                                                                                    }
                                                                                    onClick={() => {
                                                                                        setResponsesOpenKey((prev) =>
                                                                                            prev === stepResponsesKey
                                                                                                ? null
                                                                                                : stepResponsesKey
                                                                                        );
                                                                                    }}
                                                                                >
                                                                                    <FontAwesomeIcon
                                                                                        icon={
                                                                                            responsesOpenKey ===
                                                                                            stepResponsesKey
                                                                                                ? solid('chevron-up')
                                                                                                : solid('comments')
                                                                                        }
                                                                                    />
                                                                                </button>
                                                                            ) : null}
                                                                        </div>
                                                                    </td>
                                                                    <td className='text-center'>{step.step_due_date ? moment(step.step_due_date).format("DD/MM/YYYY") : '-' }</td>
                                                                    <td className='text-center'>
                                                                        {
                                                                            step.step_status === 'NI' ?
                                                                            <span className='badge bg-danger'>{STATUS_MAP[step.step_status]}</span>
                                                                            :
                                                                            null
                                                                        }
                                                                        {
                                                                                step.step_status === 'PE' ?
                                                                                <span className='badge bg-warning'>{STATUS_MAP[step.step_status]}</span>
                                                                            :
                                                                            null
                                                                        }
                                                                        {
                                                                            step.step_status === 'RE' ?
                                                                            <span className='badge bg-success'>{STATUS_MAP[step.step_status]}</span>
                                                                            :
                                                                            null
                                                                            }
                                                                        
                                                                    </td>
                                                                    <td className='text-center'>{ step.step_date_completed ? moment(step.step_date_completed).format("DD/MM/YYYY HH:mm") : '-' }</td>
                                                                    <td className='text-center'>{ step.step_score !== null && step.step_score !== '-' ? <span className='bg-green-light-50 p-2'>{Number(step.step_score).toFixed(1)}</span> : '-' }</td>
                                                                </tr>
                                                                <PerformanceReportStepCommentsRows
                                                                    useExternalToggle
                                                                    expanded={responsesOpenKey === stepResponsesKey}
                                                                    onExpandedChange={(v) =>
                                                                        setResponsesOpenKey(v ? stepResponsesKey : null)
                                                                    }
                                                                    step={step}
                                                                    itemCommentsAllowed={commentsAllowed}
                                                                    assessmentType={item.assessment_type}
                                                                />
                                                            </Fragment>
                                                            );
                                                        })
                                                    }
                                                </React.Fragment>
                                            ))}
                                            </tbody>
                                            </table>
                                        </React.Fragment>
                                    ))
                                }
                                {
                                    itemsCount > 20 ?
                                    <>
                                    <div className='float-end'>
                                        <nav>
                                            <ul className='pagination pagination-sm'>
                                                <li className='page-item'>
                                                    { 
                                                        report.previous ? 
                                                        <span onClick={subPage} className='page-link text-default'>
                                                            <FontAwesomeIcon className='' icon={solid('angle-left')} />
                                                        </span>
                                                        :
                                                        <span className='page-link text-grey disabled'>
                                                            <FontAwesomeIcon className='' icon={solid('angle-left')} />
                                                        </span>
                                                    }
                                                </li>
                                                <li className='page-item'>
                                                    {
                                                        report.next ?
                                                        <span onClick={addPage} className='page-link text-default'>
                                                            <FontAwesomeIcon className='' icon={solid('angle-right')} />
                                                        </span>
                                                        :
                                                        <span className='page-link text-grey disabled'>
                                                            <FontAwesomeIcon className='' icon={solid('angle-right')} />
                                                        </span>
                                                    }
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                    </>
                                    : null
                                }
                                </>
                                :
                                <div className='text-center'>
                                    <p className='alert'>Nenhum dado encontrado para filtro aplicado.</p>
                                </div>
                            }
            
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div id="formDel" className="modal fade" ref={modalRef}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Remover Participante</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <p>
                                Tem certeza de que deseja remover este participante do processo?
                            </p>
                            <p>
                                Colaborador: <strong>{deleteEmployeeName}</strong>
                            <br/>
                                Líder: <strong>{employeeManagerName}</strong>
                            </p>
                            <button className="btn btn-sm btn-danger btn-rounded px-4"  onClick={deleteItem}>Sim, Remover</button>
                        </div>
                    </div>
                </div>
            </div>
        </ProtectedRoute>
    )
}